import React from 'react';
import LiteralsService from 'src/services/literals/LiteralsService';
import Selectors from 'src/utils/selectors';
import CalloutGray from 'src/components/atomic/atoms/calloutGray/CalloutGray';
import { ButtonSecondary } from '@americanexpress/dls-react';
import { DLSSize } from 'src/types/dls-size.enum';
import styles from './targetMonthlySpendingCallout.module.scss';
import { useBreakpoints } from 'src/hooks/useBreakpoints';

interface Props {
    onClick: () => void;
}

export default function TargetMonthlySpendingCallout({ onClick }: Props): JSX.Element {
    const { isMinWidthSmall } = useBreakpoints();
    return (
        <CalloutGray
            heading={LiteralsService.getLiteral('TargetMonthlySpendingCallout.header')}
            body={LiteralsService.getLiteral('TargetMonthlySpendingCallout.body')}
            button={
                <ButtonSecondary
                    className={styles.button}
                    size={isMinWidthSmall ? DLSSize.SMALL : DLSSize.MEDIUM}
                    onClick={onClick}
                    data-cy={Selectors.SpendSmart.CALLOUT_BUTTON}
                >
                    {LiteralsService.getLiteral('TargetMonthlySpendingCallout.button')}
                </ButtonSecondary>
            }
            data-cy={Selectors.SpendSmart.TARGET_MONTHLY_SPENDING_CALLOUT}
        />
    );
}
